import { Filter, Calendar, Building2, CreditCard, RotateCcw } from 'lucide-react';

const PERIOD_OPTIONS = [
    { value: 'all', label: 'Todo período' },
    { value: '1m', label: 'Último mês' },
    { value: '3m', label: 'Últimos 3 meses' },
    { value: '6m', label: 'Últimos 6 meses' },
    { value: '12m', label: 'Último ano' },
];

const STATUS_OPTIONS = [
    { value: 'all', label: 'Todos' },
    { value: 'active', label: 'Ativos' },
    { value: 'trial', label: 'Em Trial' },
    { value: 'churned', label: 'Churned' },
    { value: 'suspended', label: 'Suspensos' },
    { value: 'overdue', label: 'Inadimplentes' },
];

export default function DashboardFilters({ filters, onChange, plans = [] }) {
    const planOptions = [
        { value: 'all', label: 'Todos os planos' },
        ...plans.map(p => ({ value: p.id, label: p.name })),
    ];
    const handleChange = (key, value) => {
        onChange({ ...filters, [key]: value });
    };

    const hasActiveFilters = filters.period !== 'all' || filters.status !== 'all' || filters.plan !== 'all';

    const resetFilters = () => {
        onChange({ period: 'all', status: 'all', plan: 'all' });
    };

    return (
        <div className="flex items-center gap-2 flex-wrap">
            <div className="flex items-center gap-1.5 text-foreground-muted text-xs font-medium uppercase tracking-wider mr-1">
                <Filter className="w-3.5 h-3.5" />
                Filtros
            </div>

            {/* Period Filter */}
            <div className="relative">
                <Calendar className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-foreground-muted pointer-events-none" />
                <select
                    value={filters.period}
                    onChange={(e) => handleChange('period', e.target.value)}
                    className="appearance-none pl-8 pr-7 py-1.5 bg-surface/80 border border-border rounded-lg text-foreground-secondary text-xs focus:outline-none focus:border-cyan-600 hover:border-border-strong transition-colors cursor-pointer"
                >
                    {PERIOD_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
                <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none">
                    <svg className="w-3 h-3 text-foreground-muted" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>

            {/* Status Filter */}
            <div className="relative">
                <Building2 className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-foreground-muted pointer-events-none" />
                <select
                    value={filters.status}
                    onChange={(e) => handleChange('status', e.target.value)}
                    className="appearance-none pl-8 pr-7 py-1.5 bg-surface/80 border border-border rounded-lg text-foreground-secondary text-xs focus:outline-none focus:border-cyan-600 hover:border-border-strong transition-colors cursor-pointer"
                >
                    {STATUS_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
                <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none">
                    <svg className="w-3 h-3 text-foreground-muted" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>

            {/* Plan Filter */}
            <div className="relative">
                <CreditCard className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-foreground-muted pointer-events-none" />
                <select
                    value={filters.plan}
                    onChange={(e) => handleChange('plan', e.target.value)}
                    className="appearance-none pl-8 pr-7 py-1.5 bg-surface/80 border border-border rounded-lg text-foreground-secondary text-xs focus:outline-none focus:border-cyan-600 hover:border-border-strong transition-colors cursor-pointer"
                >
                    {planOptions.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
                <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none">
                    <svg className="w-3 h-3 text-foreground-muted" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>

            {/* Reset */}
            {hasActiveFilters && (
                <button
                    onClick={resetFilters}
                    className="flex items-center gap-1 px-2 py-1.5 text-xs text-cyan-400 hover:text-cyan-300 transition-colors"
                >
                    <RotateCcw className="w-3 h-3" />
                    Limpar
                </button>
            )}
        </div>
    );
}
